module.exports = __webpack_public_path__ + "static/media/sey.2d563383.svg";